export const LibraryReportRouting = [
  {
    path: "/report-center/download/library-report/list",
    name: "material-library-report-list",
    meta: { title: "材料库存查询" },
    component: () =>
      import(
        /* webpackChunkName: "library-report" */ "@/views/report-center/library-report/list/index.vue"
      ),
  },
];
